import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'app-header-action',
  templateUrl: './header-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./header-action.component.scss'],
  standalone: false,
})
export class HeaderActionComponent {}
